export const PRICE_EXPORT_INTERVAL_OPTIONS = [
  { value: 'hour', label: 'Каждый час', hint: 'Файл обновляется в начале каждого часа.' },
  { value: 'day', label: 'Раз в день', hint: 'Файл обновляется каждую ночь в 03:00 по Москве.' },
  { value: 'week', label: 'Раз в неделю', hint: 'Файл обновляется по понедельникам в 03:00 по Москве.' },
  { value: 'month', label: 'Раз в месяц', hint: 'Файл обновляется 1-го числа каждого месяца в 03:00 по Москве.' }
];

export const PRICE_EXPORT_FORMAT_OPTIONS = {
  csv: {
    badge: 'CSV',
    title: 'CSV (UTF-8)',
    description: '1С 8.3, Excel и Google Таблицы. Разделитель — точка с запятой.'
  },
  csv1251: {
    badge: 'CSV',
    title: 'CSV (Windows-1251)',
    description: 'Для старых версий 1С и программ без поддержки UTF-8.'
  },
  xlsx: {
    badge: 'XLSX',
    title: 'Excel',
    description: 'Для Excel и «Загрузки данных из файла» в 1С.'
  },
  yml: {
    badge: 'XML',
    title: 'XML (YML)',
    description: 'Формат Яндекс Маркета — для модулей обмена и интеграций.'
  },
  json: {
    badge: 'JSON',
    title: 'JSON',
    description: 'Для разработчиков и собственных интеграций.'
  }
};

export function priceExportIntervalOption(value) {
  return PRICE_EXPORT_INTERVAL_OPTIONS.find((option) => option.value === value) || PRICE_EXPORT_INTERVAL_OPTIONS[0];
}

export function priceExportUrl(path, origin) {
  return new URL(path, origin).toString();
}

export function formatFileSize(bytes) {
  const size = Number(bytes);
  if (!Number.isFinite(size) || size <= 0) return '';
  if (size < 1024) return `${size} Б`;
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} КБ`;
  return `${(size / 1024 / 1024).toLocaleString('ru-RU', { maximumFractionDigits: 1 })} МБ`;
}

const DAY_MS = 24 * 60 * 60 * 1000;

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

export function formatExportMoment(value, now = new Date()) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  const time = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  const dayOffset = Math.round((startOfDay(date) - startOfDay(now)) / DAY_MS);
  if (dayOffset === 0) return `Сегодня, ${time}`;
  if (dayOffset === 1) return `Завтра, ${time}`;
  if (dayOffset === -1) return `Вчера, ${time}`;
  const day = date.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    ...(date.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' })
  });
  return `${day}, ${time}`;
}
